import React, { Component } from "react";
import Title from "../atoms/title"
import Trustpilot from '../molecules/trustpilot'


class Loader extends Component {
    constructor(props){
      super(props);
      this.state = {
        title: this.props.title,
        trustContent: this.props.trustContent,
        classNames: this.props.classNames,
        onComplete: this.props.onComplete,
        loaderProgress: 10,
        isComplete: false,
        isLinearLoader: this.props.isLinear,
        isCircularLoader: this.props.isCircular,
        isTrustLoader: this.props.isTrust,
        isTypingLoader: this.props.isTyping,
        forever: this.props.forever
      }
      this.activateLoader = this.activateLoader.bind(this);
      this.updateParent = this.updateParent.bind(this);

      if(this.state.isLinearLoader) this.activateLoader();
      if(this.state.isTypingLoader) this.activateTypingLoader();

    }

    activateLoader() {
        let duration = (this.state.isTrustLoader) ? 5200 : 1200;
        setTimeout(() => {
            this.setState({
                loaderProgress: 100
            });
        }, 100);
        setTimeout(() => {
            this.setState({
                isComplete: !this.state.isComplete
            });
            this.updateParent();
        }, duration);
    }

    activateTypingLoader() {
        let duration = (this.state.forever) ? 30000 : 4000;
        setTimeout(() => {
            this.setState({
                isComplete: !this.state.isComplete
            });
            this.updateParent();
        }, duration);
    }

    updateParent() {
        this.state.onComplete(this.state.isComplete);
    }

    render() {
        const createClassList = () => {
            let classList = 'cm-loader';
            if(this.state.classNames) classList = classList + ' ' + this.state.classNames;
            if(this.state.isTrustLoader) classList = classList + ' cm-loader--trust' ;
            if(this.state.isTypingLoader) classList = classList + ' cm-loader--typing' ;
            return classList;
        }
    
        const titleComponent = (this.state.title) ? (
            <div className='cm-loader__title'>
                <Title
                    type='h3'
                    title={this.state.title}
                    align='center'
                    color='dark'
                />
            </div>
        ) : null;

        const trustComponent = (this.state.isTrustLoader) ? (
            <div className='cm-loader__trust'>
                <Trustpilot
                    content={this.state.trustContent}
                />
            </div>
        ) : null;
    
        const linearLoaderInlineStyle = {
            width: this.state.loaderProgress + '%',
        };

        const linearLoaderComponent = (this.state.isLinearLoader) ? (
            <div className='cm-loader__progress-bar'>
                <div className='cm-loader__progress-bar-fill' style={linearLoaderInlineStyle}></div>
            </div>
        ) : null;

        const circularLoaderComponent = (this.state.isCircularLoader) ? (
            <div className='cm-loader__circular'>
                <div className="cm-loader__rings"><div></div><div></div><div></div><div></div></div>
            </div>
        ) : null;

        const typingLoaderComponent = (this.state.isTypingLoader) ? (
            <div className="cm-loader__typing">
                <span></span>
                <span></span>
                <span></span>
            </div>
        ): null;

        return (
            <div className={createClassList()}>
                {titleComponent}
                {trustComponent}
                {linearLoaderComponent}
                {circularLoaderComponent}
                {typingLoaderComponent}
            </div>
        );
    }
}


export default Loader;

{/* <Loader 
    title="Lorem Ipsum"
    classNames="extra__class-name--goes-here"
/> */}